(function() {
  function initProductGalleries() {
    if (typeof Splide !== 'function') return;

    document.querySelectorAll('[data-product-gallery]').forEach(function(gallery) {
      if (gallery.dataset.productGalleryReady === 'true') return;
      gallery.dataset.productGalleryReady = 'true';

      var sliderElement = gallery.querySelector('[data-product-main-slider]');
      if (!sliderElement) return;

      var thumbnails = Array.prototype.slice.call(gallery.querySelectorAll('[data-product-thumbnail]'));
      var splide = new Splide(sliderElement, {
        type: 'loop',
        autoplay: true,
        interval: 4200,
        speed: 650,
        pauseOnHover: true,
        pauseOnFocus: true,
        perPage: 1,
        gap: 0,
        arrows: false,
        pagination: false,
        drag: true,
        rewind: false
      });

      thumbnails.forEach(function(button) {
        button.addEventListener('click', function() {
          var index = parseInt(button.getAttribute('data-product-thumbnail'), 10);
          if (Number.isNaN(index)) return;
          splide.go(index);
        });
      });

      splide.on('mounted move moved active refresh resized updated', function() {
        updateActiveThumbnail(gallery, splide.index);
        prepareSplideCloneLightbox(sliderElement);
      });

      splide.mount();
      gallery._productGallerySplide = splide;
      updateActiveThumbnail(gallery, splide.index);
      prepareSplideCloneLightbox(sliderElement);
      bindSplideCloneLightbox(sliderElement);

      sliderElement.querySelectorAll('img').forEach(function(image) {
        if (image.complete) return;
        image.addEventListener('load', function() {
          if (gallery._productGallerySplide) {
            gallery._productGallerySplide.refresh();
            updateActiveThumbnail(gallery, gallery._productGallerySplide.index);
          }
        }, { once: true });
      });
    });

    if (typeof refreshFsLightbox === 'function') {
      refreshFsLightbox();
    }
  }

  function updateActiveThumbnail(gallery, index) {
    gallery.querySelectorAll('[data-product-thumbnail]').forEach(function(button) {
      var buttonIndex = parseInt(button.getAttribute('data-product-thumbnail'), 10);
      var isActive = buttonIndex === index;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function prepareSplideCloneLightbox(sliderElement) {
    sliderElement.querySelectorAll('.splide__slide--clone a[data-fslightbox]').forEach(function(link) {
      var slide = link.closest('.splide__slide');
      var gallery = link.getAttribute('data-fslightbox');
      var index = slide ? slide.getAttribute('data-splide-index') : link.getAttribute('data-gallery-index');

      if (gallery) {
        link.setAttribute('data-slider-lightbox-gallery', gallery);
      }

      if (index !== null) {
        link.setAttribute('data-slider-lightbox-index', index);
      }

      link.removeAttribute('data-fslightbox');
    });
  }

  function bindSplideCloneLightbox(sliderElement) {
    if (sliderElement.getAttribute('data-slider-lightbox-bound') === 'true') return;
    sliderElement.setAttribute('data-slider-lightbox-bound', 'true');

    sliderElement.addEventListener('click', function(event) {
      var link = event.target.closest('.splide__slide--clone a[data-slider-lightbox-gallery]');
      if (!link || !sliderElement.contains(link)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var gallery = link.getAttribute('data-slider-lightbox-gallery');
      var index = getSplideLightboxIndex(link);

      if (openFsLightboxGallery(gallery, index)) return;

      var originalLink = findOriginalSplideLightboxLink(sliderElement, gallery, index, link.getAttribute('href'));
      if (originalLink) {
        originalLink.click();
      }
    }, true);
  }

  function getSplideLightboxIndex(link) {
    var savedIndex = parseInt(link.getAttribute('data-slider-lightbox-index'), 10);
    if (!Number.isNaN(savedIndex)) return savedIndex;

    var slide = link.closest('.splide__slide');
    if (!slide) return 0;

    var slideIndex = parseInt(slide.getAttribute('data-splide-index'), 10);
    return Number.isNaN(slideIndex) ? 0 : slideIndex;
  }

  function openFsLightboxGallery(gallery, index) {
    if (!gallery || !window.fslightboxInstances) return false;

    var instance = window.fslightboxInstances[gallery];
    if (!instance || typeof instance.open !== 'function') return false;

    instance.open(index);
    return true;
  }

  function findOriginalSplideLightboxLink(sliderElement, gallery, index, href) {
    var originalLinks = Array.prototype.slice.call(sliderElement.querySelectorAll('.splide__slide:not(.splide__slide--clone) a[data-fslightbox]'));

    return originalLinks.find(function(link) {
      var slide = link.closest('.splide__slide');
      var slideIndex = slide ? parseInt(slide.getAttribute('data-splide-index'), 10) : parseInt(link.getAttribute('data-gallery-index'), 10);
      return link.getAttribute('data-fslightbox') === gallery && slideIndex === index;
    }) || originalLinks.find(function(link) {
      return link.getAttribute('data-fslightbox') === gallery && link.getAttribute('href') === href;
    }) || null;
  }

  function setActiveProductMedia(sectionId, mediaId) {
    if (!sectionId || !mediaId) return;

    var gallery = document.querySelector('#ProductGallery-' + sectionId);
    if (!gallery || !gallery._productGallerySplide) return;

    var target = gallery.querySelector('[data-media-id="' + sectionId + '-' + mediaId + '"]');
    if (!target) return;

    var index = parseInt(target.getAttribute('data-gallery-index'), 10);
    if (Number.isNaN(index)) return;

    gallery._productGallerySplide.go(index);
  }

  document.addEventListener('DOMContentLoaded', function() {
    initProductGalleries();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
        var data = event && event.data ? event.data : null;
        if (!data || !data.variant || !data.variant.featured_media) return;
        setActiveProductMedia(data.sectionId, data.variant.featured_media.id);
      });
    }
  });

  document.addEventListener('shopify:section:load', initProductGalleries);
})();
